<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      resizable
      border
      size="small"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      row-id="amzFlipOrderSkuCode"
      :checkbox-config="{
        checkMethod: checCheckboxkMethod,
      }"
      :span-method="rowspanMethod"
      @checkbox-change="onCheckboxChange"
      @checkbox-all="onCheckboxChange"
    >
      <template v-slot:toolbar_form>
        <slot name="toolbar"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg',
          ]"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 60px; height: 60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:amzMarketName="{ row }">
        <div style="display: flex;justify-items: center;align-items: center;">
          <div style="flex: 1;">
            {{ row.amzMarketName }}
          </div>
          <div class="tag">
            <span
              class="animate-ping tag-sapn absolute"
              :style="{ backgroundColor: row.alertLevelColor }"
            ></span>
            <span
              class="tag-sapn relative"
              :style="{ backgroundColor: row.alertLevelColor }"
            ></span>
          </div>
        </div>
      </template>
      <template v-slot:skuInfo="{ row }">
        <span>SKU：</span><span style="color: #303133">{{ row.amzSkuNo }}</span>
        <br />
        <span>SPU：</span><span style="color: #303133">{{ row.amzSpuNo }}</span>
        <br />
        <span>{{ row.brandName }}</span>
        <br />
        <span>{{ row.goodsName }}</span>
        <br />
        <span>{{ row.goodsNameEn }}</span>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.amzFlipOrderSkuStatus == 'N'
              ? 'info'
              : row.amzFlipOrderSkuStatus == 'C'
              ? 'warning'
              : row.amzFlipOrderSkuStatus == 'S'
              ? ''
              : row.amzFlipOrderSkuStatus == 'P'
              ? 'success'
              : row.amzFlipOrderSkuStatus == 'R'
              ? 'danger'
              : ''
          "
        >
          {{ row.v_amzFlipOrderSkuStatus }}
        </el-tag>
        <br v-if="row.amzFlipOrderSkuStatus == 'R'" />
        <span
          v-if="row.amzFlipOrderSkuStatus == 'R'"
          style="color: #F56C6C;border-bottom: 1px solid;font-size: 12px;cursor: pointer;"
          @click.stop="openRejectReason(row)"
          >{{ $l('tips_reject_reason') || '查看驳回原因' }}</span
        >
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="
                  opt.disabled == undefined ? false : opt.disabled(row)
                "
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
    <el-dialog
      title="驳回原因"
      :visible.sync="rejectReasonVisible"
      width="420px"
      v-if="rejectReasonVisible"
      :before-close="closeRejected"
    >
      <div style="white-space: pre-line;">{{ rejectReason }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="closeRejected">
          {{ $l('INDEX.btn_confirm') || '确认' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
import { format } from '@/libs/util.number.js'
import EditLoading from '@/mixins/edit-loading'

export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
      },
      format: (number) => format(number),
      tableColumns: tableColumns(this),
      endMerger: false,
      rejectReasonVisible: false,
      rejectReason: '',
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      switch (menuType) {
        case 'review':
          this.$emit('review', {
            amzFlipOrderSkuCodes: [data.amzFlipOrderSkuCode],
          })
          break
        case 'confirmOrder':
          this.$emit('confirmOrder', {
            amzFlipOrderSkuCodes: [data.amzFlipOrderSkuCode],
          })
          break
        case 'edit':
          this.$emit('edit', {
            amzFlipOrderSkuCode: data.amzFlipOrderSkuCode,
          })
          break
        case 'delete':
          this.del(data.amzFlipOrderSkuCode)
          break
      }
    },
    closeRejected() {
      this.rejectReasonVisible = false
    },
    onCheckboxChange({ records, reserves }) {
      this.$emit('choose-change', records.concat(reserves))
    },
    rowspanMethod({ row, column }) {
      const notMerger = [
        'amzMarketName',
        'dailySales',
        'fbaInv',
        'ftyInvDaysAvailable',
        'fbaSafetyStockDays',
      ]
      if (notMerger.includes(column.property)) {
        return { rowspan: 1, colspan: 1 }
      } else {
        return { rowspan: row.rowspan, colspan: 1 }
      }
    },
    checCheckboxkMethod({ row }) {
      return row.rowspan > 0
    },
    openRejectReason({ rejectReason }) {
      this.rejectReason = rejectReason
      this.rejectReasonVisible = true
    },
    del(amzFlipOrderSkuCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .ecomAmzFlipOrderSkuDelApi({ amzFlipOrderSkuCode })
          .catch(() => null)
        this.loadingClose()
        if (!res) return
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
          type: 'success',
        })
        this.$emit('reload')
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@keyframes ping {
  75%,
  100% {
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping {
  animation: ping 1.5s cubic-bezier(0, 0, 0.1, 0.6) infinite;
}
.tag {
  position: relative;
  display: inline-flex;
  justify-content: center;
}
.tag-sapn {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  opacity: 0.75;
  display: inline-flex;
}
.relative {
  position: relative;
}
.absolute {
  position: absolute;
}
</style>
